import { render } from "./preDeposit.vue?vue&type=template&id=d13628ba&scoped=true"
import script from "./preDeposit.vue?vue&type=script&lang=js"
export * from "./preDeposit.vue?vue&type=script&lang=js"

import "./preDeposit.vue?vue&type=style&index=0&id=d13628ba&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-d13628ba"

export default script